import { render } from "./AFData.vue?vue&type=template&id=671e157d&scoped=true"
import script from "./AFData.vue?vue&type=script&lang=js"
export * from "./AFData.vue?vue&type=script&lang=js"

import "./AFData.vue?vue&type=style&index=0&id=671e157d&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671e157d"]])

export default __exports__